import React from "react";
import "./HumpCount.scss";

interface IProps {
  hump: number;
}

const HumpCount = (props: IProps) => {
  
  return (
    <div id="hump-count">
      <span className="title">Kalan hak</span>
      <span className="count">{props.hump}</span>
    </div>
  );
}

export default HumpCount;
